import { capitalize } from "../../summer/constants/summerContent"
import {
    FORMAT_INFO_COPY,
    FORMAT_KEYS,
    INSCRIPTION_FORMATS,
} from "../constants/inscriptionFormats"
import { formatTileStates } from "./formulaChoice"

/**
 * Les tuiles de format prêtes à afficher : l'état de chacune
 * (`formatTileStates`) et ses mots — son nom, sa phrase, la barre de son
 * heure. Les deux écrans où le format se choisit montrent les mêmes.
 */
export const formatTiles = ({ choice, rules }) =>
    formatTileStates({ choice, rules }).map((tile) => {
        const { name, share, visits, popular } = INSCRIPTION_FORMATS[tile.key]
        return { ...tile, name, share, visits, popular: !!popular }
    })

/**
 * Les formats tels que « Une heure de {prénom} » les raconte, au prénom de
 * l'élève : `{ key, name, training, hour, beside, visits, alt }`,
 * dans l'ordre de l'écran.
 */
export const formatSessions = (firstname) =>
    FORMAT_KEYS.map((key) => {
        const format = INSCRIPTION_FORMATS[key]
        return {
            key,
            name: format.name,
            training: format.training(capitalize(firstname)),
            hour: format.hour ?? null,
            beside: !!format.beside,
            visits: format.visits,
            alt: format.alt(firstname),
        }
    })

/** Les mots communs de « Une heure de {prénom} », au prénom de l'élève. */
export const formatInfoCopy = (firstname) => ({
    ...FORMAT_INFO_COPY,
    title: FORMAT_INFO_COPY.title(firstname),
})
